
import { Organisation } from "../../../types/models/Organisation";
import { useOrgApp } from "../../context/useOrgApp";
import { useProfile } from "../../context/useProfile";

const useOrganisation = () => {
  // Get Selected Organisation
  const { orgApp } = useOrgApp();
  // Get Profile Context
  const { profile, setProfile } = useProfile();

  // Get selected organization
  const organisation = profile?.organisations?.find((org) => org.id === orgApp.organisationId) as Organisation | undefined;
  // Update selected organization
  const setOrganisation = (orga: Organisation) => {
    setProfile((currentProfile) => {
      // Check if the profile is defined and has organisations
      if (!currentProfile || !currentProfile.organisations) {
        return currentProfile;
      }

      // Map through the organisations to find the one to update
      const updatedOrganisations = currentProfile.organisations.map((org) => {
        if (org.id === orga.id) {
          // When the correct organisation is found, create a new object with updated fields
          return { ...org, ...orga };
        }
        return org;
      });

      // Return a new user object with the updated organisations array
      return { ...currentProfile, organisations: updatedOrganisations };
    });
  };

  return { organisation, setOrganisation };
};
export default useOrganisation;
